import React from 'react';
import AdSlot from 'components/ads/ad-slot';
import AdSlotCorner from 'components/ads/ad-slot-corner';
import MainLayout from './main-layout.base';
import HeaderDesktop from '../header/header.desktop';
import FooterDesktop from '../footer/footer.desktop';
import { SLOT_TOP, SLOT_SPONSORING_TOP, SLOT_SCROLLER, SLOT_CORNER } from 'components/ads/ad-slot/ad-defs';

const MainLayoutDesktop: React.FC = ({ children }) => (
    <>
        <AdSlot name={SLOT_SPONSORING_TOP} className="creation-topbar"/>
        <HeaderDesktop/>
        <AdSlot name={SLOT_TOP} className="creation-top"/>
        <MainLayout>
            {children}
        </MainLayout>
        <FooterDesktop/>
        <AdSlot name={SLOT_SCROLLER}/>
        <AdSlotCorner name={SLOT_CORNER}/>
    </>
);

export default MainLayoutDesktop;
